export class AppSpecialCasesUtils {
  getBGColor = (status: string): string => {
    switch (status) {
      case "inbound":
        return "inbound-vessel";
      case "departed":
        return "departed-vessel";
      case "created":
        return "created-vessel";
      case "closed":
        return "closed-vessel";
      case "working":
        return "working-vessel";
      case "complete":
        return "complete-vessel";
      case "arrived":
        return "arrived-vessel";
      default:
        return "";
    }
  };

  getStatusColor = (status: string): string => {
    switch (status) {
      case "yes":
        return "text-highlight-success";
      case "no":
        return "text-highlight-warning";
      default:
        return "text-highlight-warning";
    }
  };
}
